// extracted by mini-css-extract-plugin
module.exports = {"tile":"table-service-module--tile--1IOQ9","tileGrid":"table-service-module--tileGrid--3-iV9"};